@export fn getIndex(i: u32) -> u32 { return i; }